import { Box, SxProps, Theme } from '@mui/material';
import { ZapIcon } from 'lucide-react';

interface EnhancementBadgeProps {
  label: string;
  sx?: SxProps<Theme>;
}

export default function EnhancementBadge({ label, sx }: EnhancementBadgeProps) {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        gap: '4px',
        bgcolor: '#EBB540',
        color: 'primary.main',
        borderRadius: '4px',
        paddingX: '6px',
        paddingY: '2px',
        fontSize: '10px',
        fontWeight: 600,
        width: 'fit-content',
        ...sx,
      }}
    >
      <ZapIcon size={14} strokeWidth={2} />
      {label}
    </Box>
  );
}
